export const GoogleMapApiConfig = 'AIzaSyBTz0pR4qy5QPsS_s0v6Sh250SbdNGyPXw';